import { UserLangCode } from "src/utils/util.types";
import { Statistics, StatisticsType } from "../types/statistics.entity";
import { BaseStatAggregator } from "./base/base-stat-aggregator";
import { userRepository } from "src/features/users/repositories/user.repository";
import { getLastMonthTimestamp } from "../utils/stats.util";

export class UserStatsAggregator extends BaseStatAggregator {
  protected execQuery(statType: StatisticsType, langCode?: UserLangCode): Promise<number> {
    switch (statType) {
      case "TOTAL_COACHES":
        return userRepository.count({
          roles: ["COACH"],
          ...(langCode ? { "appMeta.activeCoachingLangCode": langCode } : {}),
        });

      case "LAST_MONTH_USERS":
        return userRepository.count({
          roles: { $arrayContainsAny: ["COACH", "LEARNER"] },
          ...(langCode
            ? { $or: [{ "appMeta.activeCoachingLangCode": langCode }, { "appMeta.activeLearningLangCode": langCode }] }
            : {}),
          createdAt: { $gt: getLastMonthTimestamp() },
        });
      case "TOTAL_LEARNERS":
        return userRepository.count({
          roles: ["LEARNER"],
          ...(langCode ? { "appMeta.activeLearningLangCode": langCode } : {}),
        });

      case "TOTAL_DUAL_ROLE":
        return userRepository.count({
          roles: {
            $in: [
              ["LEARNER", "COACH"],
              ["COACH", "LEARNER"],
            ],
          },
          "appMeta.activeCoachingLangCode": langCode,
          "appMeta.activeLearningLangCode": langCode,
        });

      default: // total users
        return userRepository.count({
          roles: { $arrayContainsAny: ["COACH", "LEARNER"] },
          ...(langCode
            ? { $or: [{ "appMeta.activeCoachingLangCode": langCode }, { "appMeta.activeLearningLangCode": langCode }] }
            : {}),
        });
    }
  }
}
